<button  
  *ngIf="config?.variant === buttonVariant.PRIMARY || !config.variant"  
  [disabled]="disabled"  
  [ngClass]="config.class"  
  mat-button
  class="!text-base"
  [type]="type"  
  (click)="onButtonClick($event)"  
>  
  <ng-content select="[icon]"></ng-content>
  {{ config.text }}  
</button>  

<button  
  *ngIf="config?.variant === buttonVariant.SECONDARY"  
  [disabled]="disabled"  
  [ngClass]="config.class"  
  mat-button  
  [type]="type"
  (click)="onButtonClick($event)"  
  class="!bg-green_blue !text-base"  
  [class.icon-button]="iconOnly"  
>  
  <ng-content></ng-content>  
  {{ config.text }}  
</button>  

<button  
  *ngIf="config?.variant === buttonVariant.DANGER"  
  [disabled]="disabled"  
  [ngClass]="config.class"  
  mat-button  
  [type]="type"  
  (click)="onButtonClick($event)"  
  class="!bg-danger !border-danger !text-base"  
>  
  {{ config.text }}  
</button>  

<button  
  *ngIf="config?.variant === buttonVariant.PRIMARY_OUTLINE"  
  mat-button  
  [disabled]="disabled"  
  [ngClass]="config.class"  
  [type]="type"  
  class="!border-solid !border-[#5982CE] !border-[1px] !bg-white !text-[#4663AE] !font-semibold !text-base"  
  (click)="onButtonClick($event)"  
>  
  {{ config.text }}  
</button>  

<button  
  *ngIf="config?.variant === buttonVariant.SECONDARY_OUTLINE"  
  mat-button  
  [disabled]="disabled"  
  [ngClass]="config.class"  
  [type]="type"  
  class="!border-solid !border-green_blue !border-[2px] !bg-white !text-green_blue !font-semibold !text-base"  
  (click)="onButtonClick($event)"  
>  
  {{ config.text }}  
</button>  

<button  
  *ngIf="config?.variant === buttonVariant.DARK"  
  mat-button  
  [type]="type"  
  [disabled]="disabled"  
  [ngClass]="config.class"  
  class="!border-solid !border-dark !border-[1px] !bg-dark !text-base"  
  (click)="onButtonClick($event)"  
>  
  {{ config.text }}  
</button>

<!-- validation Error -->
<mat-error *ngIf="showValidation && showError">
    {{ validation?.errorText }}
</mat-error>